import { dataResources } from '@portal-internet/core';
import styles from './RightSidePanelContent.module.scss';
import { ReactSVG } from 'react-svg';
import ButtonComponent from '../Button/ButtonComponent';
import Text from '../Text/TextComponent';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

export default function RightSidePanelContentComponent({ title, children, action, closed }) {
    const { setShowRightSidePanel } = useRedl();

    return (
        <div className={styles.redlRightSidePanelContent} data-testid="REDL-panel">
            {closed ? 
                <div className={styles.redlRightSidePanelContentClose}>
                    <ButtonComponent variant="tertiary" size="sm" onClick={() => setShowRightSidePanel(null)}>
                        <ReactSVG src={basePath + '/_resources/REDL/icons/x-lg.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                    </ButtonComponent>
                </div>
            :null}
            <div className={styles.redlRightSidePanelContentHeader}>
                <div className={styles.redlRightSidePanelContentInnerTitle}>
                    <Text tag="h2" size="lg" weight="600">{title}</Text>
                </div>
                {
                    action ?
                        <div className={styles.redlRightSidePanelContentInnerButton}>
                            <ButtonComponent variant="tertiary" size="sm"
                                             onClick={() => setShowRightSidePanel(prevState => ({
                                                 ...prevState,
                                                 size: 'lg',
                                                 action: action
                                             }))}>
                                <ReactSVG
                                    src={basePath + '/_resources/REDL/icons/chevron-right.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                            </ButtonComponent>
                        </div>
                        : null
                }
            </div>
            <div className={styles.redlRightSidePanelContentBody}>
                {children}
            </div>
        </div>
    );
}